<template>
	<div class="container__messagecontainer">
		<Message
			v-for="(message, key) in messages"
			:key="key"
			:message-id="message.messageId"
			:message-title="message.messageTitle"
			:message-list="message.messageList"
			:message-text="message.messageText"
			:message-icon="message.messageIcon"
			:message-type="message.messageType"
		/>
	</div>
</template>

<script>
import Message from '../Message/Message'
import { mapGetters } from 'vuex'

export default {
	components: { Message },
	computed: {
		...mapGetters('moduleMessages', { messages: 'getMessages' }),
	},
}
</script>

<style scped>
.container__messagecontainer {
	bottom: 0px;
	display: flex;
	flex-direction: column;
	height: auto;
	padding: 0 1rem 1rem 1rem;
	position: fixed;
	width: 100vw;
}

@media screen and (min-width: 768px) {
	.container__messagecontainer {
		width: 35rem;
		right: 0;
	}
}
</style>
